import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  fieldsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    columnGap: 16,
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr 1fr ',
      columnGap: 8
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr'
    }
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  divider: {
    marginTop: 20
  },
  switchContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginTop: 29,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'left',
      padding: '0 10px'
    }
  },
  switch: {
    width: 'auto',
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  icon: {
    fontSize: 42,
    marginTop: 24,
    marginBottom: 16
  }
}))

export default useStyles
